import { http } from "@/utils/http";

export const getHoteluxHomeEntries = () => {
  return http.post("/render/app_hotelux/util/entries", {
    data: [
      { category: "homeBanner" },
      { category: "homeExclusiveOffers", populate: "target.ref" }
    ]
  });
};

export const getHoteluxCuratedCollections = () =>
  http.get("/render/app_hotelux/home/curatedCollections");

export const getHoteluxPopularDestinations = () =>
  http.get("/render/app_hotelux/home/popularDestinations");
